module.exports = __webpack_public_path__ + "static/media/hugo_mobile_1.fa5f3992.webp";